import { useMemo } from 'react';

import { isExternalStoreUrl, primaryStoreUrl } from '../utils/storePlatform';
import { useStorePlatform } from './useStorePlatform';

/** Store URL on iOS/Android when configured; otherwise in-page download anchor. */
export function useSmartStoreHref(fallbackHref: string): string {
  const platform = useStorePlatform();
  return useMemo(() => primaryStoreUrl(platform) ?? fallbackHref, [platform, fallbackHref]);
}

export function useIsExternalStoreHref(href: string): boolean {
  return isExternalStoreUrl(href);
}
